import { apiClient } from "./client";

export type BusinessRecord = {
  _id: string;
  name?: string;
  email?: string;
  user?: {
    email?: string;
  };
};

type BusinessesResponse = {
  message?: string;
  data?: BusinessRecord[];
  businesses?: BusinessRecord[];
  items?: BusinessRecord[];
  results?: BusinessRecord[];
  meta?: {
    currentPage?: number;
    totalPages?: number;
    hasNext?: boolean;
  };
};

const normalizeBusinesses = (
  payload: BusinessesResponse | BusinessRecord[],
) => {
  const list = Array.isArray(payload)
    ? payload
    : (
    payload.data ?? payload.businesses ?? payload.items ?? payload.results ?? []
  );

  return list.map((business) => ({
    ...business,
    email: business.email ?? business.user?.email,
  }));
};

export const getAllBusinesses = async () => {
  const limit = 100;
  let page = 1;
  let hasNext = true;
  const merged: BusinessRecord[] = [];

  while (hasNext) {
    const response = await apiClient.get<BusinessesResponse | BusinessRecord[]>(
      "/v1/admin/get-all-businesses",
      {
        params: { page, limit },
      },
    );

    const payload = response.data ?? [];
    const normalized = normalizeBusinesses(payload);
    merged.push(...normalized);

    if (Array.isArray(payload)) break;

    const nextFromMeta =
      typeof payload.meta?.hasNext === "boolean"
        ? payload.meta.hasNext
        : payload.meta?.currentPage !== undefined &&
            payload.meta?.totalPages !== undefined
          ? payload.meta.currentPage < payload.meta.totalPages
          : normalized.length === limit;

    hasNext = nextFromMeta;
    page += 1;
  }

  const uniqueById = new Map<string, BusinessRecord>();
  merged.forEach((business) => {
    uniqueById.set(business._id, business);
  });

  return Array.from(uniqueById.values());
};
